import paginationComponent from "../../../components/pagination/pagination.component";
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import GscmDivisionModel from "../../../models/gscm-division/gscm-division.model";
import languageModel from "../../../models/language.model";
import ModelUDFAddEditDialog from "../../../components/udf/model-udf-add-edit.dialog";
import udfManagementModel from "../../../models/udf-management/udf-management.modal";
import ViewBase from "../../view-base.view";

/**
 * Model UDF Management View
 *
 * 
 *
 * @author cmc.nttruong1
 */

export default function ModelUDFManagement() {
  ViewBase.call(this);

  const SELECT_ALL_CHECKBOX_ID = "modelUdfSelectAllCheckbox";
  const CHECKBOX_NAME = "modelUdfCheckbox";

  const DEFAULT_FILTERS = {
    gscmDivision: "",
    attributeName: "",
  };

  const DEFAULT_PAGINATION = {
    pageSize: 10,
    pageIndex: 1,
    totalItems: 0,
  };

  let filters = structuredClone(DEFAULT_FILTERS);
  let pagination = structuredClone(DEFAULT_PAGINATION);

  let modelUdf = [];
  let selectedModelUdf = [];
  let gscmDivisionOptionList = [];

  let isModalOpen = false;

  let dataRequest = null;

  const _openModal = (data) => {
    isModalOpen = true;
    dataRequest = data;
  };

  const selectRow = (checked, item) => {
    if (checked) {
      selectedModelUdf.push(item.encryptedUdfId);
    } else {
      selectedModelUdf = selectedModelUdf.filter(
        (data) => data !== item.encryptedUdfId
      );
    }

    let selectAllCheckbox = document.querySelector(
      `#${SELECT_ALL_CHECKBOX_ID}`
    );
    if (selectedModelUdf.length === 0) {
      selectAllCheckbox.indeterminate = false;
      selectAllCheckbox.checked = false;
    }
    else {
      selectAllCheckbox.indeterminate = true;
      selectAllCheckbox.checked = false;
    }
  };

  const searchModelUdf = () => {
    this.showLoading();
    uncheckAllCheckboxes();
    udfManagementModel.searchModelUdf({ ...filters, ...pagination })
      .then((result) => {
        if (result != null) {
          modelUdf = result.data;
          pagination.totalItems = result.total;
        }
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const _initControls = () => {
    this.showLoading();

    Promise.allSettled([
      searchModelUdf(),
    ]).finally(() => {
      this.hideLoading();
    });
  };

  const getGscmDivisionList = () => {
    gscmDivisionOptionList = [];
    return GscmDivisionModel.getGscmDivisionHierarchy()
      .then((result) => {
        // due to Stored Procedure get data from the deepest layer
        let deepestLayer = result.map((e) => e['subProductHirList'])
        gscmDivisionOptionList = deepestLayer.flatMap((e) => e);
      })
      .catch((error) => {
        this.handleError(error);
      });
  };

  const clearFilter = () => {
    filters = structuredClone(DEFAULT_FILTERS);
    pagination = structuredClone(DEFAULT_PAGINATION);
    searchModelUdf();
  };

  const onCheckAll = (event) => {
    let checkboxes = document.querySelectorAll(
      `input:not([disabled])[type='checkbox'][name='${CHECKBOX_NAME}']`
    );

    selectedModelUdf = [];

    if (event.target.checked || event.target.indeterminate) {
      modelUdf.forEach((item) => {
        if (item.editable) {
          selectedModelUdf.push(item.encryptedUdfId);
        }
      });

      checkboxes.forEach((item) => {
        item.checked = true;
      });
    } else {
      checkboxes.forEach((item) => {
        item.checked = false;
      });
    }
    event.target.indeterminate = false;
  };

  const uncheckAllCheckboxes = () => {
    const arr = document.querySelectorAll(`input[name=${CHECKBOX_NAME}]`);
    if (arr.length === 0) {
      return;
    }
    arr.forEach((checkbox) => {
      checkbox.checked = false;
    });
    let selectAllCheckbox = document.querySelector(
      `#${SELECT_ALL_CHECKBOX_ID}`
    );
    selectAllCheckbox.indeterminate = false;
    selectAllCheckbox.checked = false;

    selectedModelUdf = [];
  };

  const onDeleteAction = () => {
    if (selectedModelUdf.length > 0) {
      this.showConfirm(
        this.getText("LT00000919", "Are you sure you want to delete the selected data(s)?"),
        this.getText("LT00000920", "Delete model UDF data"),
        (e) => {
          if (e == "YES") {
            udfManagementModel.deleteModelUdf(
              selectedModelUdf
            )
              .then(() => {
                _initControls();

                this.showMessage(this.getText("EM00000004", "Success"));
              })
              .catch(() => {
                this.showErrorMessage(this.getText("EM00000142", "Error"));
              });
          }
        }
      );
    } else {
      this.showErrorMessage(this.getText("LT00000719", "No items selected"));
    }
  };

  const onPageSizeChanged = (pageIndex, pageSize) => {
    pagination.pageIndex = pageIndex;
    pagination.pageSize = pageSize;
    searchModelUdf();
  };

  const onPageChanged = (pageIndex) => {
    pagination.pageIndex = pageIndex;
    searchModelUdf();
  };

  const getInputValue = (e) => {
    filters.attributeName = e.target.value;
  }

  const onDialogClose = () => {
    isModalOpen = false;

  }

  return {
    oninit: () => {
      getGscmDivisionList();
      _initControls();
    },
    view: () => {
      return [


        /* SEARCH */
        m(".d-flex.flex-column.align-items-end.gap-2.mb-3",
          m('a.btn.btn-primary[data-bs-toggle="collapse"][href="#search-section"][aria-controls="search-section"][aria-expanded="false"]',
            m("i.bi.bi-filter"),
            this.getText("LT00000232", "Filter")
          ),
          m(".collapse.show#search-section.w-100",
            m(".card",
              m(".card-body",
                m(".row.g-2",
                  m(".col-md-3.col-lg-3.position-relative",
                    m("label.form-label", this.getText("LT00000241", "GSCM Division")),
                    m(SingleSelectComponent, {
                      id: "gscmDivision",
                      items: gscmDivisionOptionList,
                      selectedItem: gscmDivisionOptionList.find(e => e.code === filters.gscmDivision),
                      onSelect: (s) => {
                        filters.gscmDivision = s.code;
                      },
                    })
                  ),

                  m(".col-md-3.col-lg-3.position-relative",
                    m("label.form-label", this.getText("LT00000922", "Attribute Name")),
                    m("input", { "class": "form-control form-input", "type": "text", "value": filters.attributeName, onkeyup: getInputValue })
                  ),

                  m(".col-12.d-flex.justify-content-end.gap-2",
                    m("button.btn.btn-primary",
                      {
                        onclick: () => {
                          pagination.pageIndex = DEFAULT_PAGINATION.pageIndex;
                          searchModelUdf();
                        },
                      },
                      this.getText("LT00000001", "Search")
                    ),
                    m("button.btn.btn-white",
                      {
                        type: "button",
                        onclick: () => {
                          clearFilter();
                        },
                      },
                      this.getText("LT00000031", "Clear")
                    )
                  )
                )
              )
            )
          )
        ),

        /* TABLE */
        m(".card",
          m(".card-body",
            m(".row.g-2",
              m(".col-12.d-flex.justify-content-between",            
                  m("button.btn.btn-danger",
                    {
                      onclick: () => {
                        onDeleteAction();
                      },
                    },
                    this.getText("LT00000821", "Delete Selected")
                  ),
                  m("button.btn.btn-primary",
                    {
                      onclick: () => {
                        _openModal(null);
                      },
                    },
                    [m("i.bi.bi-plus-lg.me-2")],
                    this.getText("LT00000058", "Create")
                ),
              ),
              m(".col-12",
                m(".table-responsive",
                  m("table.table.table-hover.sticky-column-start",
                    m("thead",
                      m("tr.align-middle",
                        m("th",
                          m("input", {
                            tabindex: -1,
                            id: SELECT_ALL_CHECKBOX_ID,
                            type: "checkbox",
                            onchange: onCheckAll,
                          })
                        ),
                        m("th", this.getText("LT00000241", "GSCM Division")),
                        m("th", this.getText("LT00000923", "Attribute ID")),
                        m("th", this.getText("LT00000922", "Attribute Name")),
                        m("th", this.getText("LT00000924", "Attribute Type")),
                        m("th", this.getText("LT00000012", "Description")),
                        m("th", this.getText("LT00000081", "Create User")),
                        m("th", this.getText("LT00000041", "Create Date")),
                        m("th", this.getText("LT00000128", "Edit"))
                      )
                    ),
                    m("tbody",
                      modelUdf.length == 0 &&
                      m("tr",
                        { class: "align-middle" },
                        m("td",
                          { colspan: "21" },
                          languageModel.getText(
                            "EM00000141",
                            "No records found."
                          )
                        )
                      ),
                      modelUdf.map((data, index) =>
                        m(`tr.align-middle.cursor-pointer`,
                          {
                            onclick: (event) => {
                              // Triggers select only when user click on the cell
                              if (event.target.localName === "td" && data.editable) {
                                document
                                  .querySelector(`#${CHECKBOX_NAME}${index}`)
                                  .dispatchEvent(new MouseEvent("click"));
                              }
                            },
                          },
                          m("td",
                            m("input", {
                              id: `${CHECKBOX_NAME}${index}`,
                              type: "checkbox",
                              tabindex: -1,
                              name: CHECKBOX_NAME,
                              onchange: (event) => {
                                selectRow(event.target.checked, data);
                              },
                              disabled: !data.editable,
                            })
                          ),
                          m("td", m("span.cursor-text", data.gscmDivision)),
                          m("td", m("span.cursor-text", data.attributeId)),
                          m("td", m("span.cursor-text", data.attributeName)),
                          m("td", m("span.cursor-text", data.attributeType)),
                          m("td", m("span.cursor-text.text-wrap", data.description)),
                          m("td", m("span.cursor-text", data.createUserID)),
                          m("td", m("span.cursor-text", data.createDate)),
                          m(
                            "td",
                            !data.attributeId.includes("GSCM") &&
                            m('i.bi.bi-pencil-square.list-action-icon[title="Edit"]',
                              {
                                onclick: () => {
                                  _openModal(data);
                                },
                              }
                            )
                          )
                        )
                      )
                    )
                  )
                )
              ),
              m(".col-12",
                m(paginationComponent, {
                  currentPage: pagination.pageIndex,
                  pageSize: pagination.pageSize,
                  totalItems: pagination.totalItems,
                  onPageChanged: onPageChanged,
                  onPageSizeChanged: onPageSizeChanged,
                })
              )
            )
          )
        ),

        /** CREATE DIALOG */
        isModalOpen &&
        m(ModelUDFAddEditDialog, {
          data: dataRequest,
          onClose: onDialogClose,
          gscmDivisionOptionList: gscmDivisionOptionList,
          onSaveComplete: () => {
            onDialogClose();
            this.showMessage(this.getText("EM00000004", "Success"));
            _initControls();
          },
        }),

        this.getBaseViews(),
      ];
    },
  };
}
